import { createSelector } from '@ngrx/store';

import { getTrustState } from '../../reducers';

export const selectTrustState = createSelector(getTrustState, (state) => state);
